<template>
    <!-- 解答 -->
    <div id="paper">
        <div class="choose">
            <p class="title_t">
                <span v-if="ask_length>1"
                      class="num">({{question.number}})、</span>
                <span v-if="question.subject.content.length"
                      :class="{'title_p':ask_length>1}"
                      v-html="question.subject.content"></span>
                <img v-if="question.subject.image.length"
                     :src="question.subject.image" />
            </p>
            <template v-if='!!checked'>
                <p class="resources"
                   @click='resources'>
                    <span>用户答案</span>
                    <i :class="[ask[index].isShow ? 'icon1' : 'icon2']"></i>
                </p>
                <ul v-show='ask[index].isShow'>
                    <p class="option_content"
                       v-if='question.right_option.content'
                       v-html='question.right_option.content'></p>
                    <li v-for="q in question.options"
                        v-if="question.options.length">
                        <i :class='[q.option == question.user_answer ? "i_equal" : "i_noequal"]'>{{q.option}}</i>
                        <p :class='[q.option == question.user_answer ? "i_equal" : "i_noequal"]'
                           v-html="q.content"></p>
                        <img :src="q.image.url"
                             v-if="q.image.url">
                    </li>
                </ul>
            </template>
            <template v-else>
                <p class="resources"
                   @click='resources'>
                    <span>参考答案</span>
                    <i :class="[ask[index].isShow ? 'icon1' : 'icon2']"></i>
                </p>
                <ul v-show='ask[index].isShow'>
                    <p class="option_content"
                       v-if='question.right_option.content'
                       v-html='question.right_option.content'></p>
                    <li v-for="q in question.options"
                        v-if="question.options.length">
                        <i :class='[q.is_right == 1 ? "i_equal" : "i_noequal"]'>{{q.option}}</i>
                        <p :class='[q.is_right == 1 ? "i_equal" : "i_noequal"]'
                           v-html="q.content"></p>
                        <img :src="q.image.url"
                             v-if="q.image.url">
                    </li>
                </ul>
            </template>
        </div>
    </div>
</template>

<script type="text/ecmascript-6">
export default {
    props: ['question', 'askLength', 'ask', 'index', "checked"],
    data () {
        return {

        }
    },
    components: {

    },
    computed: {
        ask_length () {
            return this.askLength ? this.askLength : 1
        },

    },
    beforeRouteLeave (to, from, next) {

    },
    methods: {
        resources () {
            this.question.isShow = !this.question.isShow
            this.ask.splice(this.index, 1, this.question)
            //console.log(this.ask[this.index])
        }
    },
    mounted () {

    },
    created () {
        this.ask.forEach((m, n) => {
            m.isShow = false
        })
    },
    destroyed () {

    }
}
</script>
<style rel="stylesheet/scss" lang="scss" scoped>
.title_t {
    background: #fff;
    padding: 24px / $ppr;
    line-height: 48px / $ppr;
    border-bottom: #e8e8e8 1px / $ppr solid;
    position: relative;
}
.option_content {
    padding: 0.6rem 0.6rem;
    border-bottom: #e8e8e8 1px / $ppr solid;
}
.resources {
    line-height: 2.4rem;
    height: 2.4rem;
    padding: 0 0.6rem;
    font-size: 0.6rem;
    color: #618bef;
    position: relative;
    border-bottom: #e8e8e8 1px / $ppr solid;
    i {
        width: 35px / $ppr;
        height: 20px / $ppr;
        display: inline-block;
        position: relative;
        top: 5px / $ppr;
        left: 10px / $ppr;
        &.icon2 {
            background: url("./img/icon_open.png");
            background-size: 100%;
            background-repeat: no-repeat;
        }
        &.icon1 {
            background: url("./img/icon_close.png");
            background-size: 100%;
            background-repeat: no-repeat;
        }
    }
}
.choose {
    background: #fff;
    margin-top: 24px / $ppr;
    ul {
        li {
            padding: 24px / $ppr;
            line-height: 48px / $ppr;
            border-bottom: #e8e8e8 1px / $ppr solid;
            position: relative;
            i {
                position: absolute;
                top: 24px / $ppr;
                left: 24px / $ppr;
                text-align: center;
                display: inline-block;
                width: 50px / $ppr;
                height: 50px / $ppr;
                line-height: 50px / $ppr;
                border-radius: 50%;
                &.i_equal {
                    border: #66cc22 1px / $ppr solid;
                    background: #66cc22;
                    color: #fff;
                }
                &.i_noequal {
                    border: #e8e8e8 1px / $ppr solid;
                }
            }
            p {
                display: inline-block;
                width: 580px / $ppr;
                padding-left: 80px / $ppr;
                &.p_equal {
                    color: #66cc22;
                }
            }
        }
    }
    .p {
        padding: 24px / $ppr;
        line-height: 48px / $ppr;
        border-bottom: #e8e8e8 1px / $ppr solid;
        min-height: 48px / $ppr;
    }
    position: relative;
    .taskbottom {
        line-height: 96px / $ppr;
        height: 96px / $ppr;
        padding: 0 24px / $ppr;
        font-size: 24px / $ppr;
        color: #aaa;
        position: relative;
        span:nth-of-type(2) {
            line-height: 50px / $ppr;
            text-align: center;
            width: 120px / $ppr;
            height: 50px / $ppr;
            position: absolute;
            top: 20px / $ppr;
            right: 20px / $ppr;
            border-radius: 50px / $ppr;
            border: 1px / $ppr solid red;
            &.Select {
                color: #5e89ef;
                border: 1px / $ppr solid #5e89ef;
            }
            &.remove {
                color: #ff6600;
                border: 1px / $ppr solid #ff6600;
            }
        }
    }
}
</style>
